<template>
  <div>
    <div class="premium-label">Premium Options</div>
    <div
      class="snapstore grow"
      :class="{ 'snapstore-open': isPayNowOpen && paymentMethod }"
      @click="clickPayNow"
    >
      <div class="snapstore-icon">
        <img src="/images/pack.png" class="snapstore-icon-img" />
      </div>
      <div class="snapstore-label">Snap Pack</div>
      <div class="snapstore-description">
        Contribute to help us grow our reading community and receive 5,000
        snaps.
      </div>
      <!-- <div class="snapstore-save">Save $15 on your subscription</div> -->
    </div>
    <div class="snapmod assistant-buy" v-if="isPayNowOpen && paymentMethod">
      <div class="snapmod-content" v-if="nextSnapPackDate">
        <div class="payment-line">
          <div class="payment-firstline">
            Pubby members can purchase one Snap Pack every 3 days.<br />You can
            purchase your next Snap Pack at
            <span style="font-weight: 700">{{ nextSnapPackDate }}</span
            >.<br />Please consider using one of the methods at the top of the
            page to earn more snaps until then. Thank you!
          </div>
        </div>
      </div>
      <div class="snapmod-content" v-if="nextSnapPackDate === null">
        <!-- <div class="snapmod-title">Receive Snap Pack</div> -->
        <div class="promote-option-pay" v-if="isPayNowOpen && paymentMethod">
          <div class="payment-line">
            <div class="payment-firstline">
              We're not offering Snap Packs temporarily as we work on new and
              improved ways to earn snaps. We apologize for any inconvenience
              and appreciate your patience as we continue to improve Pubby.
            </div>
          </div>

          <!-- <div class="payment-line">
            <div class="payment-firstline">
              Your card on file will be charged
              <span style="font-weight: 700">$29.99</span> and you will receive
              <span class="payment-snaps">5,000 snaps</span> immediately. Your
              contribution is used to grow our reading community through
              marketing and advertising campaigns.
            </div>
            <p style="padding-top: 12px; padding-bottom: 0; margin-bottom: 0">
              Pubby members can purchase one Snap Pack every 3 days. By
              purchasing snaps, you are not guaranteed to receive reviews. We
              will show your book to interested readers, but a reader must
              choose your book to read in order to get reviewed. While over 95%
              of books do receive reviews, some books may not get reviewed, and
              your purchase cannot be refunded.
            </p>
          </div>
          <div
            @click="confirmPayNow"
            class="payment-button payment-button-later"
            :class="{ 'payment-disabled': isPaymentDisabled }"
          >
            Confirm Order
          </div> -->
          <!-- <div @click="cancelPayNow" class="payment-button payment-button-cancel">Cancel</div> -->
          <div class="clearfix"></div>
        </div>
        <!-- <div class="payment-button">Get Access</div>
        <div class="payment-details">
          <span class="special-price">Special Introductory Price (Ending Soon)</span>
          <br />$39.99 for 6 months of unlimited access
        </div>
          <div class="clearfix"></div>-->
      </div>
    </div>
  </div>
</template>

<script>
import Back from "../../modules/Back";

export default {
  name: "SnapStore",
  props: ["user"],
  data: function() {
    return {
      paymentMethod: null,
      nextSnapPackDate: false,
      isPayNowOpen: false,
      isPaymentDisabled: false,
    };
  },
  methods: {
    toggleMore() {
      this.showMore = !this.showMore;
    },
    async purchasePack() {
      console.log("requestReview request", this.assignment);
      const response = await Back.requestAssistantReview(this.assignment);

      if (!response) {
        this.$toasted.show(
          "Oops! Something went wrong. Please try again later.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 3000,
          }
        );
        return;
      }

      this.$toasted.show("Great! We've sent this to your assistant!", {
        icon: "check_circle",
        position: "bottom-center",
        duration: 3000,
      });

      this.review = response;

      console.log("requestReview response", response);
    },
    async clickPayNow() {
      console.log("clickPageNow");
      this.isPayNowOpen = true;

      if (this.isPaymentDisabled) {
        return;
      }

      if (!this.paymentMethod) {
        this.getUserPaymentMethod();
      }
      if (!this.nextSnapPackDate) {
        this.nextSnapPackDate = await this.getSnapPackEndTime();
        console.log("nextSnapPackDate", this.nextSnapPackDate);
      }
    },
    async confirmPayNow() {
      this.isPaymentDisabled = true;
      console.log("isPaymentDisabled", this.isPaymentDisabled);
      const response = await Back.userPlaceOrder("snap-pack-30");

      console.log("paid response", response);

      if (!response) {
        this.isPaymentDisabled = false;
        return this.$toasted.show(
          "Oops! Something went wrong. Please try again later or contact our support team.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 4000,
          }
        );
      }

      this.$toasted.show(
        "Thank you for your contribution! You have received 5,000 snaps.",
        {
          icon: "check_circle",
          position: "bottom-center",
          duration: 3000,
        }
      );
      this.isPayNowOpen = false;

      setTimeout(function () {
        window.location.reload();
      }, 3000);
    },
    async getUserPaymentMethod() {
      const response = await Back.userPaymentMethod();

      if (!response) {
        this.$toasted.show(
          "Your payment method could not be found. Please contact our support team or try again later.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 4000,
          }
        );
      }

      this.paymentMethod = response;

      console.log("getUserPaymentMethod", response);
    },
    async getSnapPackEndTime() {
      const response = await Back.userNextSnapPackDate();

      console.log("response2", response);

      if (!response) {
        return null;
      }

      if (!response.date) {
        return null;
      }

      const now = new Date();
      const nowTime = new Date().getTime();

      const assignmentDate = new Date(response.date);
      const assignmentTime = assignmentDate.getTime();

      const diff =
        nowTime - (assignmentTime - now.getTimezoneOffset() * 60 * 1000);

      var earliestTime = null;

      if (diff < 259200 * 1000) {
        if (!earliestTime || assignmentTime < earliestTime) {
          earliestTime = assignmentTime;
        }
      }

      const earliestDate = new Date(earliestTime);
      const options = { year: "numeric", month: "long", day: "numeric" };
      //return earliestDate.getTimezoneOffset() / 60;
      return (
        earliestDate.toLocaleDateString("en-US", options) +
        " " +
        earliestDate.toLocaleTimeString("en-US")
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.snapstore {
  margin: 20px auto;
  margin-bottom: 0px;
  width: 400px;
  padding-top: 0px;
  padding-top: 14px;
  padding-bottom: 30px;
  font-family: $font-family;
  //border: 4px solid #d7f3ff;
  background: lighten(#fff2c4, 8%);
  border-radius: 20px;
}

.snapstore-open {
  border-radius: 20px 20px 0 0 !important;
}

.grow {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.grow:hover {
  transform: scale(1.03);
}

.premium-label {
  padding: 14px 0 8px 0;
  color: $color-blue;
  color: #111;
  letter-spacing: 1px;
  font-size: 13pt;
  font-weight: 700;
  text-transform: uppercase;
  font-family: "Source Sans Pro";
  text-align: center;
}

.snapstore-icon {
  text-align: center;
  margin-top: 16px;
}
.snapstore-icon-img {
  width: 94px;
}

.snapstore-label {
  margin-top: -8px;
  font-size: 17pt;
  font-weight: 600;
  color: #111;
  font-family: "Source Sans Pro";
  text-align: center;
}

.snapstore-button {
  display: block;
  margin: 0 auto;
  margin-top: 16px;
  padding-top: 12px;
  padding-bottom: 12px;
  width: 200px;
  border-radius: 52px;
  border: 0px solid #ddd;
  cursor: pointer;
}
.snapstore-description {
  font-size: 12pt;
  padding: 12px 40px 0px 40px;
  text-align: center;
}
.snapstore-save {
  background: lighten(#fff2c4, 0%);
  margin: 0px auto;
  margin-top: 14px;
  width: 260px;
  border-radius: 100px;
  font-size: 12pt;
  padding: 4px 0px 5px 0px;
  font-weight: 700;
  text-align: center;
  color: $color-snaps;
  color: #333;
}

.snapmod {
  font-family: $font-family;
  background: #e9f6ff;
  background: lighten(#fff2c4, 8%);
  border-top: 0;
  margin-top: 0 !important;
}
.snapmod-content {
  width: 640px;
  margin: 0 auto;
  padding-bottom: 50px;
}
.snapmod-title {
  padding-top: 6px;
  font-weight: 400;
  color: $color-snaps;
  font-size: 24pt;
  color: #111;
}

.payment-line {
  border-top: 0;
  padding-top: 0 !important;
  margin-top: 12px !important;
}

.payment-firstline {
  font-size: 15pt;
}

.payment-snaps {
  color: $color-snaps;
  font-weight: 700;
}

.payment-disabled {
  border: 2px solid #bbb !important;
  background: #999 !important;
  color: #fff !important;
}
</style>
